import { useTranslation } from 'react-i18next';

import { useMutation } from '@tanstack/react-query';

import { postAskResetPassword } from './api';

export const useAskResetPassword = () => {
  const { t } = useTranslation();

  const { mutate, isPending, isError, isSuccess } = useMutation({
    mutationFn: postAskResetPassword,
  });

  return {
    onAskResetPassword: mutate,
    isPending,
    error: isError ? t('auth resetPasswordError') : null,
    confirmationMessage: isSuccess ? t('auth resetPasswordEmailSent') : null,
  };
};
